export const housekeeping = {
  // ── Página (index) ──
  title: "Limpieza",
  remindersBtn: "Recordatorios",
  refresh: "Actualizar",
  aboutToLeaveTitle: "Huéspedes a punto de salir hoy",
  aboutToLeaveCount: "{count} a punto de salir",
  remindersTitle: "Configurar recordatorios de limpieza",

  headline: {
    allDone: "¡Todo al día! No hay nada por limpiar ahora.",
    inProgress: "Limpieza en marcha · {count} en proceso",
    toClean: "¿Qué hay que limpiar hoy? {count} por limpiar",
    toCleanWithProgress: "¿Qué hay que limpiar hoy? {toClean} por limpiar · {inProgress} en proceso",
  },

  allProperties: "Todas las propiedades",
  searchPlaceholder: "Buscar habitación, huésped…",

  // Chips de filtro por estado (etiqueta)
  chips: {
    all: "Todos",
    to_clean: "Por limpiar",
    in_progress: "En proceso",
    occupied: "Ocupadas",
    clean: "Disponibles",
    out_of_service: "Fuera de servicio",
  },
  // Chips de filtro por estado (tooltip)
  chipTips: {
    all: "Todos los espacios de hoy, sin filtrar.",
    to_clean: "Pendientes de limpieza: marcadas sucias, con salida hoy sin limpiar, o estancias largas a las que les toca según el intervalo.",
    in_progress: "Limpieza en curso ahora mismo.",
    occupied: "Con huésped dentro (estancia en curso, no sale hoy).",
    clean: "Limpias y listas para el próximo huésped (incluye las inspeccionadas).",
    out_of_service: "No disponibles para limpiar (avería o mantenimiento).",
  },

  loadingBoard: "Cargando tablero…",
  emptyToClean: "¡Todo limpio! No hay espacios pendientes ahora mismo.",
  emptyStatus: "No hay espacios en este estado.",
  emptySearch: "No hay espacios que coincidan con la búsqueda.",

  typeHotel: "Hotel",
  typeApartment: "Apartamento",

  // Insignias de fila
  stayDue: "Toca limpieza",
  hourlyStayDue: "Salió por horas",
  hourlyStayAt: "Salió a las {time}",
  overdue: "Atrasada",
  overdueSince: "Sin limpiar desde el {date} · {days} días",
  overdueGuests: "{n} huéspedes se han ido sin que constara limpieza",
  // La franja de una estancia por horas en marcha, en la fila del tablero.
  hourlyInUse: "De {from} a {to}",
  // El cliente sigue dentro y su hora de fin ya pasó.
  hourlyOverdue: "Se pasó de hora",
  alreadyLeft: "Ya salió",
  aboutToLeave: "A punto de salir",
  cleanBadge: "Limpia",
  inspectedBadge: "Inspeccionada",

  // Turnover (sale uno / entra otro)
  departs: "↑ Sale",
  arrives: "↓ Entra",
  guestFallback: "Huésped",
  departsOn: "· sale {date}",

  // Acciones de fila
  assign: "Asignar",
  reassignTitle: "Reasignar quién limpia",
  assignWhoTitle: "Asignar a quién limpia",
  start: "Iniciar",
  startTitle: "Marcar en proceso",
  cleanAction: "Limpia",
  cleanTitle: "Completar limpieza (fotos y observaciones)",
  tasks: "Tareas",
  tasksTitle: "Tareas y detalle",

  toastSaved: "Recordatorios de limpieza actualizados",

  // Estado efectivo (etiqueta)
  status: {
    to_clean: "Por limpiar",
    in_progress: "En proceso",
    occupied: "En uso",
    clean: "Disponible",
    inspected: "Inspeccionada",
    out_of_service: "Fuera de servicio",
  },
  // Estado efectivo (tooltip)
  statusTip: {
    to_clean: "Esperando limpieza.",
    in_progress: "Limpieza en curso.",
    occupied: "En uso: huésped dentro.",
    clean: "Limpia y lista para el próximo huésped.",
    inspected: "Limpia y verificada por un supervisor.",
    out_of_service: "Fuera de servicio: no se puede limpiar (avería/mantenimiento).",
  },
  // Ocupación (etiqueta)
  occupancy: {
    vacant: "Libre",
    occupied: "Ocupada",
    departure_today: "Sale hoy",
    arrival_today: "Llega hoy",
    turnover: "Salida y entrada",
  },
  // Ocupación (tooltip)
  occupancyTip: {
    vacant: "Sin huésped: libre.",
    occupied: "Huésped dentro (estancia en curso).",
    departure_today: "El huésped sale hoy: quedará para limpiar.",
    arrival_today: "Llega un huésped hoy: debe estar lista a tiempo.",
    turnover: "Sale un huésped y entra otro hoy: limpieza urgente entre ambos.",
  },

  roles: {
    limpieza: "Limpieza",
    mantenimiento: "Mantenimiento",
    recepcion: "Recepción",
    gestor: "Gestor",
    propietario: "Propietario",
  },

  // Motivo de limpieza a mitad de estancia
  stayTip: {
    fallback: "Toca limpieza de estancia",
    daysSince: "{count} día | {count} días",
    interval: "cada día | cada {count} días",
    main: "El huésped sigue alojado. Lleva {since} sin limpiarse y toca {interval}.",
  },

  // Temporizador de la ventana de limpieza
  timer: {
    approx: " (aprox.)",
    overdue: "Entrada vencida",
    overdueTitle: "La hora de entrada ({checkin}) ya pasó · prioriza esta limpieza",
    remaining: "{dur} p/ entrada",
    remainingTitle: "Quedan {dur} hasta la entrada ({checkin})",
  },

  // ── Modal de recordatorios ──
  remind: {
    title: "Recordatorios de limpieza",
    subtitle: "Avisa a tu equipo cuando una habitación con entrada/salida próxima no está lista.",
    close: "Cerrar",
    scopeLabel: "¿A qué propiedades?",
    scopeOne: "Esta propiedad",
    scopeAll: "Todas",
    summary: "{enabled} de {total} propiedades con recordatorios activos.",
    propertyLabel: "Propiedad",
    activeSuffix: " · activo",
    propertyHelp: "Cada propiedad guarda su propio horario.",
    allNotePre: "Se aplicará la misma configuración a tus ",
    allNotePost: " propiedades (cada una a su hora local).",
    arrivalsTitle: "Llegadas y salidas",
    longStayTitle: "Reservas de larga estancia",
    daysBeforeLabel: "¿Con cuánta antelación?",
    daysBefore: {
      same: "Solo el mismo día",
      upTo: "Hasta {count} día antes | Hasta {count} días antes",
    },
    daysBeforeHelp: "Mira las llegadas/salidas dentro de esta ventana.",
    intervalLabel: "¿Cada cuántos días hay que limpiar?",
    interval: "Cada día | Cada {count} días",
    intervalHelp: "Se cuenta desde la última limpieza. La habitación aparecerá en «Por limpiar» aunque siga ocupada.",
    timeLabel: "¿A qué hora se envían?",
    timeHelp: "Hora local de la propiedad. Una vez al día.",
    recipientsLabel: "¿A quién se le avisa?",
    note: "Se envían en cola (notificación + push) y cada aviso queda registrado en las notificaciones.",
    cancel: "Cancelar",
    saving: "Guardando…",
    saveAll: "Guardar en todas",
    save: "Guardar",
    recipients: {
      assigned: "Asignados",
      team: "Equipo",
      both: "Ambos",
    },
    recipientHelp: {
      assigned: "Solo las personas asignadas a esa habitación.",
      team: "Todo el equipo de limpieza/mantenimiento de la propiedad.",
      both: "Los asignados y el equipo de la propiedad.",
    },
    longStayOff: "Desactivados",
    longStaySub: "Cada día de estancia | Cada {count} días de estancia",
    toggleAllOn: "Se activarán en todas",
    toggleAllOff: "Se desactivarán en todas",
    toggleOneOn: "Activados para esta propiedad",
    toggleOneOff: "Desactivados",
  },

  // ── Modal de completar limpieza ──
  complete: {
    title: "Completar limpieza",
    dropStrong: "Arrastra fotos aquí",
    dropRest: "o haz clic para seleccionar",
    dropHint: "Evidencia del estado de la habitación · JPG, PNG, WEBP",
    photoAlt: "foto",
    saved: "Guardada",
    view: "Ver",
    remove: "Quitar",
    notes: "Observaciones",
    notesPlaceholder: "Incidencias, desperfectos, faltantes… (opcional)",
    cancel: "Cancelar",
    uploading: "Subiendo… {pct}%",
    saving: "Guardando…",
    submit: "Marcar como limpia",
    previewAlt: "previsualización",
  },

  // ── Modal de asignación ──
  assignModal: {
    title: "¿Quién limpia este espacio?",
    allOption: "Todos",
    allDesc: "Lo ve todo el personal de limpieza y mantenimiento",
    roleSection: "Asignar a un rol",
    peopleTitle: "O elige personas",
    peopleHint: "(una o varias)",
    emptyPre: "No tienes miembros de equipo todavía. Puedes asignar por rol, o añadir personas en ",
    emptyTeam: "Equipo",
    emptyPost: ".",
    cancel: "Cancelar",
    saving: "Guardando…",
    save: "Guardar asignación",
  },

  // ── Planificación: el calendario de limpiezas futuras ──
  plan: {
    title: "Planificación de limpiezas",
    viewToday: "Hoy",
    viewPlan: "Planificación",
    loading: "Cargando el calendario…",
    loadError: "No se pudo cargar el calendario.",
    saveError: "No se pudo guardar. Inténtalo otra vez.",
    empty: "No hay limpiezas en estas fechas.",
    space: "Espacio",
    prev: "Días anteriores",
    next: "Días siguientes",
    today: "Hoy",
    days: "{n} días",
    anyone: "Cualquiera",
    unassigned: "Sin asignar",
    headline: {
      nothing: "No hay nada pendiente en estas fechas.",
      all: "{total} limpiezas pendientes · {urgentes} urgentes",
      withOrphans: "{total} pendientes · {urgentes} urgentes · {sin} sin asignar",
    },
    types: {
      turnover: "Sale y entra",
      arrastre: "Atrasada",
      salida: "Salida",
      estancia: "Estancia larga",
      manual: "Marcada a mano",
    },
    abbr: { all: "TOD", turnover: "TURN", arrastre: "ATR", salida: "SAL", estancia: "EST", manual: "MAN" },
    windowGuessed: "Horas de la casa: este alojamiento no tiene las suyas puestas",
    legendTight: "Margen justo entre salida y entrada",
    noRoomTip: "{n} salidas sin habitación asignada todavía",
    windowTip: "Entre la salida ({desde}) y la entrada ({hasta}) hay {min} minutos",
    roleShort: "ROL",
    roleFull: "Asignada a un rol, no a una persona",
    fromSpace: "asignación fija del espacio",
    nobody: "Sin asignar — pulsa para elegir a alguien",
    dow: { mon: "L", tue: "M", wed: "X", thu: "J", fri: "V", sat: "S", sun: "D" },

    teamRows: "Reparto del equipo",

    teamTitle: "Equipo",
    capacity: "Capacidad",
    capacityTitle: "Cuántas limpiezas aguanta cada persona al día",
    done: "Listo",
    perDay: "Al día",
    dayOffTip: "Marcar como día libre",
    noStaff: "Todavía no tienes personal de limpieza. Añade personas en Equipo y aquí verás su carga.",
    shortHands: "Faltan manos: {dias}",
    loadTip: "{dia}: {n} de {cap}",
    loadTipOff: "{dia}: día libre ({n} asignadas)",
    hasNow: "{n} asignadas · aguanta {cap} al día",

    selected: "{n} elegidas",
    assignTo: "Asignar a…",
    assignBtn: "Asignar {n}",
    people: "Personas",
    noteTitle: "Nota para esta limpieza",
    notePlaceholder: "Llega tarde, prioriza…",
    unassign: "Quitar",
    clear: "Deseleccionar",
    assigned: "{n} limpiezas asignadas",
    unassigned2: "Asignación quitada",
    partial: "{n} asignadas, {mal} no se pudieron",
    autoAssign: "Repartir automático",
    nothingToAssign: "No hay nada sin asignar en estas fechas.",
    proposalTitle: "Propuesta de reparto",
    proposalSub: "{n} limpiezas repartidas. Revísalo antes de aplicarlo.",
    proposalApply: "Aplicar el reparto",
    proposalUncovered: "{n} sin cubrir",
    cancel: "Cancelar",
    uncovered: {
      nadie_tiene_esta_propiedad: "nadie tiene esa propiedad asignada",
      nadie_trabaja_ese_dia: "nadie trabaja ese día",
      equipo_lleno: "el equipo está al límite",
    },
    rejected: {
      espacio_ajeno: "Ese espacio no es de tu cuenta.",
      persona_ajena: "Esa persona no es de tu equipo.",
      persona_sin_la_propiedad: "Esa persona no tiene asignada esta propiedad. Asígnasela en Equipo primero.",
      rol_desconocido: "Ese rol no existe.",
      datos_incompletos: "Faltan datos de la limpieza.",
      error_al_guardar: "No se pudo guardar.",
    },
    autoAssignN: "Repartir {n}",
    seeDay: "Ver el día",
    filtering: "Filtrando por",
    showingOf: "viendo {n} de {total}",
    emptyFiltered: "Ningún resultado con estos filtros. Hay {total} limpiezas en estas fechas.",
    moreFilters: "Más filtros",
    roomy: "Cómoda",
    dense: "Compacta",
    ofN: "de {n} limpiezas",
    addPerson: "Añadir a alguien al equipo",
    notCleaner: "No es personal de limpieza, pero tiene trabajo asignado",
    teamCap: "{n} al día",
    teamFoot: "La carga es de todo el rango; los filtros no la cambian.",
    perDayN: "{n} al día",
    closedN: "{n} cerradas",
    capMax: "El máximo son {n} al día",
    rowHint: "Alt + clic para elegir toda la fila",
    daySheetTip: "Pulsa para ver el día · Alt + clic para elegirlo entero",
    keysHint: "1-9 asigna · A abre · Esc limpia",
    undo: "Deshacer",
    undone: "Reparto restaurado",
    tightDay: "El {dia} hay {n} limpiezas",
    tightMore1: "y 1 día más",
    tightMoreN: "y {n} días más",
    proposalDetail: "Ver el reparto limpieza a limpieza",
    nobody2: "Nadie todavía",
    warnDayOff: "{quien} libra el {dia}.",
    warnOver: "{quien} se pone en {n} el {dia} y aguanta {cap}.",
    onDay: "{dia}: {n} + {mas} de {cap}",
    onDays: "{dias} días: {n} de {cap}",
    c: {
      pending: "Pendientes",
      urgent: "Urgentes",
      tight: "Días apretados",
      done: "Hechas",
      noRoom: "Sin habitación",
    },
    rows: {
      withWork: "con trabajo",
      all: "todos",
      help: "«Todos» muestra también los espacios que en estas fechas no hay que limpiar.",
      forced: "Con un filtro puesto solo se enseñan los espacios que tienen trabajo.",
    },
    f: {
      any: "Cualquiera",
      urgency: "Urgencia",
      window: "Ventana",
      state: "Estado",
      unitType: "Tipo de espacio",
      clear: "Limpiar filtros",
    },
    urg: {
      urgente: "Entra alguien ese día",
      alta: "Entra al día siguiente",
      normal: "Entra en 2-3 días",
      baja: "Nadie entra detrás",
    },
    holg: { amplia: "Holgada", justa: "Justa", imposible: "No da tiempo" },
    estados: {
      pendiente: "Pendiente",
      en_curso: "En proceso",
      hecha: "Hecha",
      fuera_de_servicio: "Fuera de servicio",
    },
    motivos: {
      faltan_manos: "faltan manos para {n}",
      con_hora_limite: "{n} con hora límite",
      varios_edificios: "{n} edificios distintos",
    },
    sheet: {
      autoDay: "Repartir este día",
      assignAll: "Asignar las {n}",
      nCleanings: "{n} limpiezas",
      nUnassigned: "{n} sin asignar",
      covers: "el equipo cubre {n}",
      empty: "Nada que limpiar este día.",
    },
    tip: {
      outIn: "sale · entra",
      lateSold: "salida tardía vendida",
      earlySold: "entrada anticipada",
      noName: "Sin nombre",
      pax: "{n} pax",
      nights: "{n} noches",
      min: "{n} min",
      h: "{h} h",
      hm: "{h} h {m}",
      stillIn: "sigue alojado",
      freeNobody: "queda libre",
      freeNone: "entra otro",
      freeDay1: "libre 1 día",
      freeDaysN: "libre {n} días",
      houseHours: "horas de la casa",
      openSpace: "Ficha del espacio", openSpaceHint: "Se abre en el tablero de Hoy, con su estado, sus tareas y su historial",
      select: "Elegir",
      deselect: "Quitar de la selección",
      assignedBy: "Lo asignó {quien}",
    },
  },
};
